
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { FIREARM_STORAGE_LOCATION_METADATA } from './firearm-storage-location.metadata';
import { FirearmStorageLocation } from './firearm-storage-location.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class FirearmStorageLocationEntityDecoratorBase extends GenericEntityDecorator<FirearmStorageLocation, number> {
  constructor() {
    super(FIREARM_STORAGE_LOCATION_METADATA, {
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.firearmStorageLocationId == null) {
      return null;
    }
    return parseInt(params.firearmStorageLocationId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: FirearmStorageLocation): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




